<template>
  <div class="cost-info">
    <div class="form-container">
      <div class="flex">
        <el-select class="white w200" clearable v-model="form.warehouseId" placeholder="请选择仓库">
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="gray date"
          v-model="form.date"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择月份"
        ></el-date-picker>
        <el-button class="btn-blue" @click="openExcel">费用导入</el-button>
      </div>
    </div>
    <div class="table-container">
      <div class="btn-list">
        <div class="btn-left">
          <el-button
            type="text"
            class="btn-text"
            :class="type === 1 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(1)"
            >成本</el-button
          >
          <el-button
            type="text"
            class="btn-text"
            :class="type === 2 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(2)"
            >管理</el-button
          >
          <el-button
            type="text"
            class="btn-text"
            :class="type === 3 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(3)"
            >销售</el-button
          >
          <el-button
            type="text"
            class="btn-text"
            :class="type === 4 ? 'btn-select' : 'btn-no-select'"
            @click="selectType(4)"
            >财务</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="costAllocationRulesVal" label="成本分摊规则"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <div :class="scope.row.status == 1? 'open-status':'close-status'">
                <i class="el-icon-warning"></i>
                <span>{{scope.row.statusVal}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button class="btn-text" type="text" @click="setType(scope.row)">设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 设置 -->
    <el-dialog title="设置" top="20vh" :visible.sync="setDialog" width="420px" :before-close="closeSet">
      <div class="border"></div>
      <div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="成本分摊规则：" prop="costAllocationRules">
            <el-radio-group v-model="ruleForm.costAllocationRules">
              <el-radio :label="1">订单数量</el-radio>
              <el-radio :label="2">分摊面积</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeSet"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmSet"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 费用导入 -->
    <el-dialog title="费用导入" top="20vh" :visible.sync="promptingDialog" width="420px" :before-close="closeOrderDown">
      <div class="border"></div>
      <div>
        <div>
          <i class="el-icon-warning"></i>
          <span class="sub-title introduce">功能介绍</span>
        </div>
        <p class="tips">导入项目商品信息，完善订单数据</p>
      </div>
      <div class="down-tmp">
        <div class="sub-title">
          <span>下载导入模板</span>
          <span class="sub-tips">(点击下载)</span>
        </div>
        <el-button type="text" class="btn-text" @click="downTmp">费用导入模板.xlsx</el-button>
      </div>
      <div>
        <p class="sub-title">费用导入</p>
        <el-upload
          v-if="isUpload"
          :disabled="form.warehouseId && form.date ? false : true"
          v-loading.fullscreen.lock="loading3"
          element-loading-text="文件上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" type="text" class="btn-text"
          @click="watch"
            >{{uploadTipsName}}</el-button
          >
        </el-upload>
        <div v-else class="upload-tips-container">
          <div class="upload-tips-name">
            {{uploadTipsName}}
            <i class="el-icon-error" @click="removeUploadOrder"></i>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeOrderDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmOrderDown"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Expenses from "models/expenses";
const expenses = new Expenses();
import CostInfo from "models/cost-info";
import { downLoadFile } from "common/js/util";
export default {
  data() {
    return {
      form: {
        warehouseId: "",
        date: ''
      },
      warehouseList: [],
      type: 1,
      tableData: [],
      costAllocationRulesType: {
        1: '订单数量',
        2: '分摊面积'
      },
      statusType: {
        1: '已开启',
        0: '已关闭'
      },

      loading3: false,
      promptingDialog: false,
      uploadTipsName: '点击导入',
      /* wms订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,

      setDialog: false,
      ruleForm: {
        costAllocationRules: '',
        status: '',
        id: '',
      }
    };
  },
  created() {
    this.getTableData();
    this.getWarehouseList()
  },
  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    //获取列表
    getTableData() {
      let type = this.type;
      let data = {
        type
      }
      CostInfo.getCostInfoList(data).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.type = value.type;
            obj.costAllocationRules = value.allocationRule;
            obj.costAllocationRulesVal = this.costAllocationRulesType[value.allocationRule];
            obj.status = value.statisticsStatus;
            obj.statusVal = this.statusType[value.statisticsStatus];
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },
    //切换类型
    selectType(type) {
      this.type = type;
      this.getTableData();
    },
    setType(row) {
      this.ruleForm.id = row.id
      this.ruleForm.status = row.status
      this.ruleForm.costAllocationRules = row.costAllocationRules
      this.setDialog = true
    },
    
    watch() {
      if (!this.form.warehouseId) {
        return this.$message.error("请选择仓库");
      }
      if (!this.form.date) {
        return this.$message.error("请选择月份");
      }
    },
    downTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E5%85%B6%E4%BB%96%E6%88%90%E6%9C%AC%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      downLoadFile('费用导入模板',url)
    },
    closeOrderDown() {
      this.removeUploadOrder()
      this.promptingDialog = false
    },
    confirmOrderDown() {
      if (this.isUpload) {
        return this.$message.error("请导入文件");
      }
      CostInfo
        .postExcel(this.formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.closeOrderDown()
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          this.$message.error("导入失败");
        });
    },
    removeUploadOrder() {
      this.formData = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
    },
    //导入Excel表格
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("warehouseId", this.form.warehouseId);
      formData.append("reportDate", this.form.date);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },
    openExcel() {
      this.promptingDialog = true
    },

    closeSet() {
      this.setDialog = false
    },
    confirmSet() {
      let id = this.ruleForm.id
      let allocationRule = this.ruleForm.costAllocationRules
      let status = this.ruleForm.status
      let data = {
        id,
        status,
        allocationRule
      }
      CostInfo.postModCostInfo(data).then(res => {
        if (res.success) {
          this.getTableData()
          this.closeSet()
        } else {
          this.$message.error(res.message);
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.cost-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  .form-container {
    padding: 16px;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    .flex {
      display: flex;
      .btn-blue {
        margin-left: 16px;
      }
    }
    .date {
      margin: 0px 20px;
    }
  }
  .table-container {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .btn-list {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      border-bottom: 1px solid #F1F1F1;
      .btn-left {
        display: flex;
        .btn-select {
          font-weight: bold;
          color: #2e68ea;
          border-bottom: 1px solid #2e68ea;
          padding: 0px 8px 12px 8px;
          margin-right: 16px;
          border-radius: 0px;
          font-size: 16px;
        }
        .btn-no-select {
          font-weight: bold;
          color: #666666;
          padding: 0px 8px 12px 8px;
          margin-right: 16px;
          border-radius: 0px;
          font-size: 16px;
        }
      }
    }
    .table {
      .is-disabled {
        color: #999999;
      }
      .open-status {
        width: 70px;
        height: 24px;
        display: flex;
        align-items: center;
        background: #E4F5EF;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #22A979;
        padding-left: 4px;
        i {
          color: #22A979;
          vertical-align: middle;
        }
      }
      .close-status {
        width: 70px;
        height: 24px;
        display: flex;
        align-items: center;
        background: #FFEDE7;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #FF6A3A;
        padding-left: 4px;
        i {
          color: #FF6A3A;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.cost-info {
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: auto;
  }
  .down-tmp {
    margin-bottom: 8px;
  }
  .el-icon-warning {
    font-size: 16px;
    color: #F47A25;
    margin-right: 6px;
    vertical-align: middle;
  }
  .sub-title {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .introduce {
    display: inline-block;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin: 11px 0px 21px 0px;
  }
  .upload-tips-container {
    position: relative;
    width: 180px;
    .upload-tips-name {
      height: 30px;
      line-height: 30px;
      margin: 12px 0px;
      color: #2E68EA;
      background: #EBEEF5;
      border-radius: 2px;
      padding-left: 7px;
      box-sizing: border-box;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -8px;
        color: #999999;
        cursor: pointer;
      }
    }
  }
  .sub-tips {
    color: #999999;
  }
  .dialog-footer {
    margin-top: 16px;
    border-top: 1px solid #f7f7f7;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    .btn-white {
      margin-right: 20px;
    }
  }
}
</style>
